import { UseQueryResult, useQuery } from 'react-query';
import { GetUserAuditHistoryResponse } from '@cbinsights/userv2service/userv2service';
import { GetUserAuditHistory } from '.';
import { getUserAuditHistory } from '../api/GetUserAuditHistory';

type Params = Parameters<typeof getUserAuditHistory>[0];
type Return = GetUserAuditHistoryResponse;

export const useGetUserAuditHistory = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetUserAuditHistory, Params]>(
    ['GetUserAuditHistory', params],
    () => getUserAuditHistory(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
